import angular from 'angular';
import quickbooksComponent from './quickbooks.component';
import transaction from './capabilities/transaction/transaction';
import transactionDetails from './capabilities/transaction-details/transaction-details';
import customerMapping from './capabilities/customer-mapping/customer-mapping';
import contractMapping from './capabilities/contract-mapping/contract-mapping';
import projectMapping from './capabilities/project-mapping/project-mapping';
import chargeCodeMapping from './capabilities/charge-code-mapping/charge-code-mapping';
import payrollExpenseMapping from "./capabilities/payroll-expense-mapping/payroll-expense-mapping";

let quickbooksModule = angular.module('quickbooks', [
  transaction.name,
  transactionDetails.name,
  customerMapping.name,
  contractMapping.name,
  projectMapping.name,
  chargeCodeMapping.name,
  payrollExpenseMapping.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider.state('quickbooks', {
    parent: 'app',
    url: '/admin/integrations/quickbooks',
    data: {
      pageHeader: true,
      pageTitle: 'Quickbooks Integration Capabilities',
      pageDesc: '',
      breadcrumbLink: 'admin.integrations',
      breadcrumbText: 'View All Integrations'
    },
    template: '<quickbooks></quickbooks>'
  })



})

.component('quickbooks', quickbooksComponent);

export default quickbooksModule;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/quickbooks.js